import { render, staticRenderFns } from "./CityComparison.vue?vue&type=template&id=0407c8a8&scoped=true&"
import script from "./CityComparison.vue?vue&type=script&lang=js&"
export * from "./CityComparison.vue?vue&type=script&lang=js&"
import style0 from "./CityComparison.vue?vue&type=style&index=0&id=0407c8a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0407c8a8",
  null
  
)

export default component.exports